<template>
	<v-container grid-list-xl>
			<v-layout row wrap>
        <v-flex lg12>
          <p style="font-size:12px !important;" v-if="globalModalParams.type == 'customer'">Add additional Customer contact email address/es here that will be used only for this quote. You can add multiple email addresses by separating each one with a comma eg. - person1@customer.com,person2@customer.com</p>
          <p style="font-size:12px !important;" v-else>Add additional Vendor contact email address/es here that will be used only for this quote. You can add multiple email addresses by separating each one with a comma eg. - person1@vendor.com,person2@vendor.com</p>
          <v-text-field v-if="globalModalParams.type == 'customer'" v-model="emails" solo></v-text-field>
          <v-text-field v-else v-model="emails" solo></v-text-field>
        </v-flex>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right" color="success" @click.stop="fncUpdate">Update</v-btn>
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          </div>
        </div>
</v-layout>

	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";

	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
			  search: '',
			  emails: ''
			};
		},
		methods: {
	    fncUpdate() {
	      if( this.globalModalParams.type == 'customer' ) {
          // this.globalModalParams.quote.customer_recipient = this.emails;
          this.$store.dispatch({
            type: 'fncSetCustomerRecipient',
            quote: this.globalModalParams.quote.id,
            emails: this.emails
          });
          // this.$store.dispatch('fncSetCustomerRecipient', this.globalModalParams.quote);
        } else {
          // this.globalModalParams.quote.vendor_recipient = this.emails;
          this.$store.dispatch({
            type: 'fncSetVendorRecipient',
            quote: this.globalModalParams.quote.id,
            emails: this.emails
          });
          // this.$store.dispatch('fncSetVendorRecipient', this.globalModalParams.quote);
        }
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      }
		},
    mounted() {
	    if( this.globalModalParams.type == 'customer' ) {
        this.emails = this.globalModalParams.quote.customer_recipient;
      } else {
        this.emails = this.globalModalParams.quote.vendor_recipient;
      }
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
